namespace GeniuzPOS.Inventory {
    export enum PostSequenceFgstatus {
        TranDate = 1,
        DocDate = 2
    }
    Serenity.Decorators.registerEnumType(PostSequenceFgstatus, 'GeniuzPOS.Inventory.PostSequenceFgstatus');
}
